import React, { Component } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWhatsapp, faGithub, faFacebook, faLinkedin, faInstagram} from "@fortawesome/free-brands-svg-icons";

class Footer extends Component {
  render() {


      if(this.props.data){
       var linkedin = this.props.data.linkedin;
       var whatsapp = this.props.data.whatsapp;
       var github = this.props.data.github;
       var facebook = this.props.data.facebook;
       var instagram = this.props.data.instagram;
        }

    return (
      <footer>

     <div className="row">
        <div className="twelve columns">
           <ul className="social-links">
               <li key="linkedIn"><a href={linkedin} target="_blank"><FontAwesomeIcon icon={faLinkedin}/></a></li>
               <li key="whatsapp"><a href={whatsapp} target="_blank"><FontAwesomeIcon icon={faWhatsapp}/></a></li>
               <li key="github"><a href={github} target="_blank"><FontAwesomeIcon icon={faGithub}/></a></li>
               <li key="facebook"><a href={facebook} target="_blank"><FontAwesomeIcon icon={faFacebook}/></a></li>
               <li key="instagram"><a href={instagram} target="_blank"><FontAwesomeIcon icon={faInstagram}/></a></li>
           </ul>

           <ul className="copyright">
              <li>&copy; Copyright 2020 Ankit Goswami</li>
           </ul>

        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
     </div>
  </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js